import { ClassNames, useTheme } from '@emotion/react';
import { type ForwardedRef, forwardRef, memo } from 'react';
import { type ItemInterface, ReactSortable, type ReactSortableProps } from 'react-sortablejs';

export const SortableBase = forwardRef(
  (
    {
      animation,
      easing,
      ghostClass = null,
      fallbackClass = null,
      ...props
    }: ReactSortableProps<ItemInterface>,
    ref: ForwardedRef<ReactSortable<ItemInterface>>,
  ) => {
    const theme = useTheme();

    return (
      <ClassNames>
        {({ css, cx }) => (
          <ReactSortable
            {...props}
            ref={ref}
            animation={animation === undefined ? theme.transitions.default.duration : animation}
            easing={easing === undefined ? theme.transitions.default.easing : easing}
            // Hide the item being dragged inside the list (otherwise it is duplicated).
            ghostClass={cx(
              ghostClass,
              css`
                opacity: 0;
              `,
            )}
            // The dragged item opacity cannot be overriden with the HTML5 dnd API.
            // So force sortable not to use it and set the opacity to 1.
            forceFallback
            fallbackClass={cx(
              fallbackClass,
              css`
                opacity: 1 !important;
              `,
            )}
          />
        )}
      </ClassNames>
    );
  },
);

SortableBase.displayName = 'Sortable';

export const Sortable = memo(SortableBase);
